<template>
  <v-card class="pa-5">
    <v-row align="center">
      <v-col cols="auto">
        <v-chip color="primary">{{ deviceStatusDisplay }}</v-chip>
      </v-col>
      <v-col cols="auto">
        <v-row></v-row>
        <div class="available-state"><span class="id font-weight-medium">{{ info.model }}:</span><span class="state-value primary--text font-weight-medium pl-2">{{ rentalStatusDisplay }}</span></div><small>{{ $t('bikeInfoCard.batteryLeft', { battery: info.battery }) }}</small>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto"><small>{{ $t('bikeInfoCard.latestUpdate') }}</small><span class="d-block font-weight-medium">{{ info.updateAt }}</span></v-col>
    </v-row>
  </v-card>
</template>

<script>
import { BIKE_STATUS, RENTAL_STATUS } from '@/libs/enum'

export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    deviceStatusDisplay () {
      const key = BIKE_STATUS[this.info.status]
      return this.$t(`deviceStatus.${key}`)
    },
    rentalStatusDisplay () {
      const key = RENTAL_STATUS[this.info.rental]
      return this.$t(`rentalStatus.${key}`)
    }
  }
}
</script>
